import { render, staticRenderFns } from "./shops.vue?vue&type=template&id=9317e648&scoped=true&"
import script from "./shops.vue?vue&type=script&lang=ts&"
export * from "./shops.vue?vue&type=script&lang=ts&"
import style0 from "./shops.vue?vue&type=style&index=0&id=9317e648&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9317e648",
  null
  
)

export default component.exports